export const statusRowContentFuture = (date, hour) => `        
<div class="hour">${hour}</div>
<div class="date">${date}</div>
`